import { render } from "./InsertData.vue?vue&type=template&id=20d47b87"
import script from "./InsertData.vue?vue&type=script&lang=js"
export * from "./InsertData.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__